import styled from 'src/styles'

import { ButtonGoogleLogin as ButtonGoogleLoginBase } from 'src/components/button-google-login'

export const ButtonGoogleLogin = styled(ButtonGoogleLoginBase)`
  margin-bottom: 18px;
`
